var path = '/static/assets/khapps/dss/dss_pestdisease/osr_sclerotinia/SclerotiniaToolbar.html';
var html = "<md-button class=\"md-body-1\" ng-click=\"recordFloweringStatus()\"\">\n    {{ 'cropPestDisease.record_flowering_status' | translate }}\n</md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;